import React, { useState } from 'react'
import { func, any } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { EMPTY_OBJECT } from '../../utils/constants'
import { useLocalStorage } from '../../helpers/hooks'
import Button from '../ui/button/Button'
import Input from '../ui/input/Input'
import { UNIT_LABELS, FEET, METER, MIN, MAX, INPUT_AREA_REGEX } from './constants'
import { meterToFeet, feetToMeter } from './helpers'
import { messages } from './messages'

const RIGHT_DIRECTION = 'right'

/**
 * Component to handle Area Filter
 *
 * @component
 * @example
 * return (
 *   <AreaFilter
 *    data={{
 *     min: 15
 *     max: 2300
 *    }
 *    onApply={() => {}}
 *   />
 * )
*/
const AreaFilter = ({ min = EMPTY_OBJECT, max = EMPTY_OBJECT, onApply }) => {
  // We are using localStorage to handle the active unit of measurement, when 'isMeter' is null the active unit is 'feet'
  // By default the active unit is 'feet'
  const [isMeter, setActiveMeter, removeActiveMeter] = useLocalStorage(METER, null)
  const [value, setValues] = useState({
    min: isMeter ? Math.round(min) : meterToFeet(min),
    max: isMeter ? Math.round(max) : meterToFeet(max)
  })
  const label = isMeter ? UNIT_LABELS.meter : UNIT_LABELS.feet

  const onChange = (e, key) => {
    if (INPUT_AREA_REGEX.test(e.target.value) || e.target.value === '') {
      setValues({ ...value, [key]: +e.target.value })
    }
  }

  const setActiveFeetCallback = e => {
    if (!isMeter) {
      return
    }
    removeActiveMeter(METER)
    setValues({ min: meterToFeet(+value.min), max: meterToFeet(value.max) })
  }

  const setActiveMeterCallback = e => {
    if (isMeter) {
      return
    }
    setActiveMeter(METER, 'active')
    setValues({ min: feetToMeter(value.min), max: feetToMeter(value.max) })
  }

  const unitButtonsClasses = { customClasses: 'react-btn--outline', activeClass: 'react-btn--outline-active' }

  return (
    <div className='area-filter'>
      <section className='area-filter__units'>
        <Button
          onClick={setActiveFeetCallback}
          active={!isMeter}
          {...unitButtonsClasses}
          dangerouslySetInnerHTML={{ __html: UNIT_LABELS[FEET] }}
        />
        <Button
          onClick={setActiveMeterCallback}
          active={!!isMeter}
          {...unitButtonsClasses}
          dangerouslySetInnerHTML={{ __html: UNIT_LABELS[METER] }}
        />
      </section>
      <section className='area-filter__inputs'>
        <Input
          value={value.min}
          labelDirection={RIGHT_DIRECTION}
          innerLabelHTML
          onChange={e => onChange(e, MIN)}
          label={label}
        />
        <Input
          value={value.max}
          labelDirection={RIGHT_DIRECTION}
          innerLabelHTML
          onChange={e => onChange(e, MAX)}
          label={label}
        />
      </section>
      <section className='area-filter__apply'>
        <Button onClick={e => onApply(e, value)} mainClass='afd-btn'><FormattedMessage {...messages.apply} /></Button>
      </section>
    </div>
  )
}

AreaFilter.propTypes = {
  /**
   * Min value
   */
  min: any,
  /**
   * Max value
   */
  max: any,
  /**
   * Function that makes the request with current parameters
   */
  onApply: func
}

export default AreaFilter
